import React, { useCallback, useEffect, useRef, useState } from 'react';
import FaeHeader from '../../components/FaeHeader';
import { closeFAEOrder, getFAEOrderDetail } from '@/api/technical';
import { useLocation, useNavigate } from 'react-router-dom';
import DetailList from './DetailList';
import HistoryList from './HistoryList';

import './index.less';
import { Spin } from 'antd';
const prefix = 'fae-order-detail';

const OrderDetail: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = useRef<any>(new URLSearchParams(location.search));

  const id = useRef<any>(searchParams.current.get('id'));
  const backClick = useCallback(() => {
    console.log('backClick');
    navigate('/technicalSupport/fae/order');
  }, [])
  const [orderDetail, setOrderDetail] = useState<any>(0)
  const getDetail = useCallback(
    /**
     * 获取编辑的 项目工单详情
     * 
     */
    () => {

      getFAEOrderDetail(id.current).then(res => {

        if (res.code == 200) {
          console.log(res);
          setOrderDetail(res?.result)
        }
      }).catch((err) => {
        console.error(err)
      })
    }, [])
  const closeOrder = useCallback(
    /**
     * 关闭工单
     */
    () => {
      closeFAEOrder(id.current).then(res => {
        if (res.code == 200) {
          navigate('/technicalSupport/fae/order');
          window.message.success(res?.message);
        }else{
          window.message.error(res?.message);
        }
      }).catch(err => {
        console.error(err);
         if (err?.message) {
          window.message.error(err.message);
        }
      })
    }, [])
  useEffect(() => {
    getDetail();
  }, [])
  return (
    <div className={`${prefix} main-wrapper`}>
      <FaeHeader title="我的工单" backClick={backClick} />
      <Spin size='large' spinning={orderDetail == 0}>
        <DetailList orderDetail={orderDetail} />
        <HistoryList orderDetail={orderDetail} closeOrder={closeOrder} updateDetail={getDetail}/>
      </Spin>

    </div>
  );
};

export default OrderDetail;
